<template>
    <b-layout
        :type="LAYOUT_TYPES.TOP_SIDE"
        :logo="logo"
        :menus="menus"
        :title="title"
        :i18nRender="i18nRender"
        :activeMenus="activeMenus"
    >
        <router-view-custom :alive="true" />
        <template #header-right>
            <right-content />
        </template>
    </b-layout>
</template>

<script>
import logo from '@/assets/icons/BMW_Grey-Colour_RGB.svg';

import i18n from '@/locales';
import RouterView from '@/layout/light/RouteView.js';
import RightContent from '@/layout/light/components/RightHeader';
import Layout, { LAYOUT_TYPES } from '@/layout/light/index';

export default {
    name:'LayoutDefault',
    components: {
        [Layout.name]: Layout,
        [RouterView.name]: RouterView,
        [RightContent.name]: RightContent
    },
    data() {
        return {
            logo,
            title: process.env.VUE_APP_TITLE,
            i18nRender: (k) => i18n.t(k),
            LAYOUT_TYPES
        };
    },
    computed: {
        menus() {
            return this.$store.state.menu.menus[0].children;
        },
        activeMenus() {
            return this.$route.matched.slice(1)
                ? this.$route.matched.slice(1).map((item) => item.path)
                : [];
        }
    }
};
</script>
